import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that automatically scrolls to the top of the page
 * whenever the route changes. This ensures a consistent user experience
 * when navigating between pages.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    document.getElementById('root')?.scrollIntoView({ behavior: 'instant' });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
